import type { LiveEvent, LiveProvider } from '@refinedev/core'
import type { Socket } from 'socket.io-client'

import { PLATFORM_LIVE_CHANNELS } from '@/lib/platform-live-channels'

export const LIVE_CONNECTION_EVENTS = {
	CONNECTED: 'connected',
	DISCONNECTED: 'disconnected',
} as const

function connectionEvent(type: string): LiveEvent {
	return { channel: PLATFORM_LIVE_CHANNELS.CONNECTION, type, payload: {}, date: new Date() }
}

export function createLiveProvider(socket: Socket): LiveProvider {
	return {
		subscribe: ({ channel, types = ['*'], params, callback }) => {
			if (channel === PLATFORM_LIVE_CHANNELS.CONNECTION) {
				const onConnect = () => { callback(connectionEvent(LIVE_CONNECTION_EVENTS.CONNECTED)); }
				const onDisconnect = () => { callback(connectionEvent(LIVE_CONNECTION_EVENTS.DISCONNECTED)); }
				socket.on('connect', onConnect)
				socket.on('disconnect', onDisconnect)
				callback(connectionEvent(socket.connected ? LIVE_CONNECTION_EVENTS.CONNECTED : LIVE_CONNECTION_EVENTS.DISCONNECTED))
				return {
					channel,
					unsubscribe: () => {
						socket.off('connect', onConnect)
						socket.off('disconnect', onDisconnect)
					},
				}
			}

			const listener = (event: LiveEvent) => {
				if (!types.includes('*') && !types.includes(event.type)) {
					return
				}

				if (event?.payload?.ids && params?.ids) {
					const eventIds = event.payload.ids.map(String)
					const subscribedIds = params.ids.map(String)
					if (!subscribedIds.some((id) => eventIds.includes(id))) {
						return
					}
				}

				callback(event)
			}

			socket.on(channel, listener)
			return { channel, listener }
		},
		unsubscribe: (subscription) => {
			if (!subscription) return
			if (typeof subscription.unsubscribe === 'function') {
				subscription.unsubscribe()
				return
			}
			socket.off(subscription.channel, subscription.listener)
		},
	}
}
